export default __webpack_public_path__ + "static/media/Background_00119.a63e039f.png";